import { render, staticRenderFns } from "./FadeTransition.vue?vue&type=template&id=28ee4180&"
import script from "./FadeTransition.vue?vue&type=script&lang=js&"
export * from "./FadeTransition.vue?vue&type=script&lang=js&"
import style0 from "./FadeTransition.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports